import React, { useState, useEffect } from 'react';
import * as Sentry from '@sentry/nextjs';
import styled from 'styled-components';
import * as DOMPurify from 'dompurify';
import { useNavInfoContext } from 'providers/NavInfoProvider';

const purifyCfg = {
  ALLOWED_TAGS: ['p', 'strong'],
  ALLOWED_ATTR: ['class'],
};

const configURL = {
  nonLive:
    'https://deo.shopeemobile.com/shopee/shopee-seatalkcdn-test-sg/seatalk-banner-config.json',
  live: 'https://deo.shopeemobile.com/shopee/shopee-seatalkcdn-live-sg/seatalk-banner-config.json',
};

const Container = styled.div`
  background-color: lightyellow;

  display: flex;
  flex-direction: column;
  width: auto;
  padding: 1em;
  z-index: 6;

  p {
    margin: 0;
    color: black;
    font-size: 14px;
    margin-bottom: 0.5em;
  }

  p.title {
    color: red;
    font-weight: 700;
    font-size: 18px;
  }

  strong {
    font-weight: 700;
  }
`;

function MaintenanceBanner() {
  const { isMobileMenuOpen } = useNavInfoContext();
  const [maintenanceConfig, setMaintenanceConfig] = useState(null);

  useEffect(() => {
    const getMaintenanceConfig = async () => {
      const targetConfigUrl =
        process.env.ENV === 'live' ? configURL.live : configURL.nonLive;

      try {
        const res = await fetch(targetConfigUrl);
        const resJson = await res.json();
        setMaintenanceConfig({
          ...resJson,
          content: DOMPurify.sanitize(resJson.content, purifyCfg),
        });
      } catch (err) {
        setMaintenanceConfig(null);

        Sentry.captureException(
          new Error(`Error on API ${targetConfigUrl}: ${err}`)
        );
      }
    };
    getMaintenanceConfig();
  }, []);

  if (!isMobileMenuOpen && maintenanceConfig?.show.help_center) {
    return (
      <Container
        dangerouslySetInnerHTML={{
          __html: maintenanceConfig?.content,
        }}
      />
    );
  }

  return null;
}

export default MaintenanceBanner;
